import React, { Component } from 'react'
import PropTypes from 'prop-types'
import style from './TextSwitcher.less'

class TextSwitcher extends Component {

  constructor(props) {
    super(props)
    this.state = {
      selectedIndex: props.selectedIndex != null ? props.selectedIndex : 0,
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedIndex !== this.props.selectedIndex) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        selectedIndex: this.props.selectedIndex != null ? this.props.selectedIndex : 0,
      })
    }
  }

  getIfActive = (index) => (
    (index == this.state.selectedIndex) ?
      style.active : null
  )

  createItem = (item, index) => (
    <button
      className={this.getIfActive(index)}
      key={index}
      onClick={() => this.itemClick(item, index)}
    >
      {item.label}
    </button>
  )

  itemClick = (activeItem, selectedIndex) => {
    this.setState({ selectedIndex })
    this.props.onChange(activeItem.data)
  }

  render() {
    const { data } = this.props

    return (
      <div className={style.main}>
        {data && data.map(this.createItem)}
      </div>
    )
  }
}


TextSwitcher.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.element.isRequired,
    data: PropTypes.string.isRequired,
  })).isRequired,
  selectedIndex: PropTypes.number,
  onChange: PropTypes.func.isRequired,
}

export default TextSwitcher
